import UrlPattern from 'url-pattern';

type Params = Record<string, null | string> | null | undefined;

export const getUrlParams = <Keys extends string>(
  key: Keys,
  location: string,
): Params => {
  const pattern = new UrlPattern(key);
  return pattern.match(location);
};

export const getLocationFromPattern = <Keys extends string>(
  key: Keys,
  params: Params,
): string => {
  const pattern = new UrlPattern(key);
  return pattern.stringify({ ...params, _: '' });
};
